$(function() {
        var tab = getParameterByName("type");

        //check selected tab
        // if (tab == 'sodai') {
        //     $('.trash-type-oversize').show();
        //     $('.trash-type-normal').hide();
        //     $('.select-trash-type-tab-left').removeClass('active');
        //     $('.select-trash-type-tab-right').addClass('active');
        // } else {
        //     $('.trash-type-oversize').hide();
        //     $('.trash-type-normal').show();
        //     $('.select-trash-type-tab-left').addClass('active');
        //     $('.select-trash-type-tab-right').removeClass('active');
        // }

        if (tab == 'sodai') {
            $('.trash-content-display').removeClass('d-none');
            $('.trash-type-oversize').show();
            $('.trash-type-normal').hide();
            $("a[data-link='trash-type-oversize']").addClass('active');
            $("a[data-link='trash-type-normal']").removeClass('active');

        } else {
            $('.trash-type-oversize').hide();
            $('.trash-type-normal').show();
            $("a[data-link='trash-type-oversize']").removeClass('active');
            $("a[data-link='trash-type-normal']").addClass('active');
        }

        //handle click tab
        
        $(".select-trash-1").click(function() {
            $('.trash-type-normal').addClass('show-tab-table');
            $('.trash-type-oversize').removeClass('show-tab-table');
            $(this).addClass('active');
            $('.select-trash-2').removeClass('active');
        });
        $(".select-trash-2").click(function() {
            $('.trash-type-oversize').addClass('show-tab-table');
            $('.trash-type-normal').removeClass('show-tab-table');
            $(this).addClass('active');
            $('.select-trash-1').removeClass('active');
        });
        $(".onClickTab1").click(function() {
            $('.trash-type-normal-1').addClass('show-tab-table');
            $('.trash-type-oversize-1').removeClass('show-tab-table');
            $(this).addClass('active');
            $('.onClickTab2').removeClass('active');
        });
        $(".onClickTab2").click(function() {
            $('.trash-type-oversize-1').addClass('show-tab-table');
            $('.trash-type-normal-1').removeClass('show-tab-table');
            $(this).addClass('active');
            $('.onClickTab1').removeClass('active');
        });

        //handle sodai elements
        var oversizeInputs = $('.oversize-input');
        oversizeInputs.each(function(index) {
            var item = $(this);
            var itemValue = item.val();
            if (!itemValue || itemValue ==0) {
                item.prop('disabled', true);
            }
        });

        $('.oversize-checkbox').click(function () {
            $showInput = $(this).data('input');
            $showData = $(this).prop('checked');
            if ($showData) {
                $('.' + $showInput).parent().addClass('active');
                $('.' + $showInput).prop('disabled', false).val(1);
            } else {
                $('.' + $showInput).parent().removeClass('active');
                $('.' + $showInput).prop('disabled', true).val(0);
            }
        });

        $(document).on('click', '.form-input-adjustable.active', function (e) {
            $currentVal = parseInt($('.oversize-input', this).val());
            if (e.offsetX > e.target.offsetLeft) {
                if (e.offsetX > 86) {
                    //click plust button
                    $('.oversize-input', this).val($currentVal + 1);
                } else {
                    //click minus button
                    $resultMinus = $currentVal - 1 < 1 ? 1 : $currentVal - 1;
                    $('.oversize-input', this).val($resultMinus);
                }
            } else {
                //console.log('out')
            }
        });
        
        function getParameterByName(name) {
            name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
            var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
                results = regex.exec(location.search);
            return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
        }
        function replaceQueryParam(param, newval, search) {
            var regex = new RegExp("([?;&])" + param + "[^&;]*[;&]?");
            var query = search.replace(regex, "$1").replace(/&$/, '');

            return (query.length > 2 ? query + "&" : "?") + (newval ? param + "=" + newval : '');
        }
    
});
